import React, { useState, useEffect } from 'react';
import conversionService from '../services/conversion';

function CurrencyConverter(props) {

    const [val, setVal] = useState("");

    useEffect(() => {
        if (props.from && props.to && props.amount) {
            conversionService.convert({
                from: props.from,
                to: props.to,
                amount: props.amount
            })
                .then(result => {
                    if (result.data) {
                        setVal(result.data.value);
                    }
                });
        }
    }, []);

    return (
        <div>{val}</div>
    );
}

export default CurrencyConverter;